import styled from "styled-components";

const PageContainer = styled.section`
    margin-bottom: 30px;
`;

const PerPageContainer = styled.section`
    .per-page-container-inner {
    }
`;

export { PageContainer, PerPageContainer };
